<template>
  <div class="product" :data-productname="product.base_name" :data-discount="product.discount_text" :class="[
    { expanded: expanded },
    market,
    { first_product: firstProduct(product) },
    { disabled: disabled },
    { cheapest: showRank && showFocus },
  ]">
    <div v-if="showRank" class="product-rank">
      <span class="product-inner-rank">{{ product.rank }}</span>
    </div>
    <div v-if="showRank && showFocus" class="product-cheapest">
      <icon icon="x-fa-trophy" size="s" />
      <span>De goedkoopste keuze voor jou</span>
    </div>
    <div class="product-overlay" />
    <div class="element provider_logo" :class="logoClass">
      <slot name="providerLogo">
        <a v-if="!product.disabled" v-bind="linkAttributes" :data-mc-cval="mcCval" :data-mc-pt="mcProductType"
          :data-mc-pid="mcProductId" @click="productClickOut()">
          <img :src="product.provider_logo" :alt="product.provider_name" :title="product.provider_name">
        </a>
        <a v-if="product.disabled" href="#" @click.prevent>
          <img :src="product.provider_logo" :alt="product.provider_name" :title="product.provider_name">
        </a>
      </slot>
      <div v-if="priceFocusFormat" class="cashback_label"
        :class="[cashbackNegative ? 'cashback_label_negative' : '', market]">
        <slot name="discountLabel">
          <span v-if="product.discount_text" class="usp">
            <span class="attention">Aanbieding </span>
            <span>{{ product.discount_text.replace(',00', '') }}</span>
          </span>
        </slot>
      </div>
    </div>

    <div v-if="product.internet" class="element base_name">
      <slot name="baseName" />
    </div>

    <div v-if="!priceFocusFormat" class="elementcontainer">
      <div class="row product-card-icon-row">
        <slot name="headerElements">
          <!-- to be filled with max. 3 product-card-icon-elements -->
        </slot>
      </div>
    </div>

    <div class="element price">
      <div class="price-container" @click="clickPrice()">
        <slot name="price">
          <span class="supertitle">
            {{ toCurrencyShort(product.total_price) }}
          </span>
          <span>per maand</span>
        </slot>
      </div>
      <div v-if="priceFocusFormat" class="element cta" @click="productClickOut()">
        <a v-if="!product.disabled" class="btn primary" role="button" v-bind="linkAttributes" :data-mc-cval="mcCval"
          :data-mc-pt="mcProductType" :data-mc-pid="mcProductId">
          <span>
            <slot name="ctaLabel">
              Bekijk deal
            </slot>
          </span>
        </a>
        <a v-if="product.disabled" class="btn primary" href="#" @click.prevent>
          <span>
            <slot name="ctaLabel">
              Bekijk deal
            </slot>
          </span>
        </a>
      </div>
    </div>


    <div ref="uspBox" class="element usps" :class="[{ expanded: expanded }, market]">
        <div class="usp-list">
          <!-- <slot name="discountLabel" v-if="!priceFocusFormat">
            <span v-if="product.discount_text" class="usp usp-attention">
              <span class="attention"><icon icon="x-fa-tag" size="m"></icon> {{ product.discount_text.replace(',00', '') }}</span>
            </span>
          </slot> -->

          <slot name="uspListStart" />

          <slot name="uspList">
            <template v-for="usp in usps">
              <product-card-usp :icon="usp[0]">
                <span>{{ usp[1] }}</span>
              </product-card-usp>
            </template>
          </slot>

          <slot name="uspListEnd" />
        </div>
    </div>

    <div v-if="expanded" class="element more-info">
      <slot name="productInfo" />
    </div>

    <div class="element more" :class="{ expanded: expanded }" @click="toggleExpandInfo()">
      <slot name="moreButtonLabel">
        <transition name="fade" mode="out-in">
          <span v-if="!expanded" key="on">Meer info</span>
          <span v-else key="off">Minder info</span>
        </transition>
        <icon icon="x-fa-plus" size="m" />
      </slot>
    </div>

    <div v-if="product.internet" class="element cta_container">
      <div class="cta internet">
        <a v-if="!product.disabled" class="btn primary" role="button" v-bind="linkAttributes" :data-mc-cval="mcCval"
          :data-mc-pt="mcProductType" :data-mc-pid="mcProductId" @click="productClickOut()">
          <span>
            <slot name="ctaLabel">
              Bekijk
            </slot>
          </span>
        </a>
        <a v-if="product.disabled" href="#" class="btn primary" @click.prevent>
          <span>
            <slot name="ctaLabel">
              Bekijk
            </slot>
          </span>
        </a>
      </div>

      <div v-if="product.internet" class="element shipping_time">
        <slot name="shippingTime" />
      </div>
    </div>

    <div v-else :class="['element', 'cta', market]">
      <a v-if="!product.disabled" class="btn primary" role="button" v-bind="linkAttributes" :data-mc-cval="mcCval"
        :data-mc-pt="mcProductType" :data-mc-pid="mcProductId" @click="productClickOut()">
        <span>
          <slot name="ctaLabel">
            Bekijk
          </slot>
        </span>
      </a>
      <a v-if="product.disabled" href="#" class="btn primary" @click.prevent>
        <span>
          <slot name="ctaLabel">
            Bekijk
          </slot>
        </span>
      </a>
    </div>

    <slot name="bottom" />
  </div>
</template>

<script>
import { useRouter } from 'vue-router';
import Icon from '../icon/Icon.vue';
import ProductCardUsp from './ProductCardUsp.vue';
import Mixins from '../comparison-lib/mixins.js';
import { useOrderStore } from '../../shared/energyComparer/stores/orderStore.js';
import { logAnalyticsEvent } from '../../../assets/js/helpers/bananas.js';

export default {
  mixins: [Mixins()],
  props: [
    'product',
    'location', // Used for URL generation
    'usps',
    'expanded',
    'signupRoute',
    'mcCval',
    'mcProductId',
    'mcProductType',
    'market',
    'cashbackNegative',
    'disabled',
    'outclickEventData',
    'showFocus',
  ],
  setup() {
    const router = useRouter();
    const orderStore = useOrderStore();

    return {
      router,
      orderStore,
    };
  },
  components: {
    Icon,
    ProductCardUsp,
  },
  computed: {
    logoClass() {
      if (this.market === 'energy') {
        return 'logo_small';
      }
      return 'logo_regular';
    },
    showRank() {
      return true;
    },
    priceFocusFormat() {
      if (this.market === 'energy') {
        return true;
      }
      return false;
    },
    switchLayout() {
      if (this.market === 'energy') {
        return true;
      }
      return false;
    },
    linkAttributes() {
      return this.product.orderline
        ? false
        : {
          target: '_blank',
          rel: 'nofollow',
          href: this.signupRoute,
        };
    },
  },
  methods: {
    firstProduct(product) {
      return product.rank === 1;
    },
    toggleExpandInfo() {
      // Expanding is ignored when product is disabled
      if (!this.disabled) {
        logAnalyticsEvent('compare-energy.product-card-more-info', {
          tab: 'no-tab',
          product_name: this.product.base_name,
        });

        this.$emit('update:expanded', !this.expanded);
      }
    },
    clickPrice() {
      if (!this.disabled) {
        this.$emit('clickPrice');
      }
    },
    productClickOut() {
      const clickOutEventData = {
        product_id: this.mcProductId,
        rank: this.product.rank,
        provider_name: this.product.provider_name,
        conversion_value: this.mcCval,
        outclick_type: this.product.orderline ? 'orderline' : 'outclick-screen',
        ...this.outclickEventData,
      };

      // Log outclick (this used to happen in the outclick screen, but is now moved to CTA)
      this.logAnalyticsEvent(`compare-${this.market}.outclick`, clickOutEventData);

      // let isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

      if (this.product.orderline) {
        if (!this.disabled) {
          this.orderStore.setProduct(this.product);
          this.router.push({ name: 'form' });
          this.$emit('productClick', this.product);
        }
      } else {
        // Product click is ignored when product is disabled
        if (!this.disabled) {
          this.$emit('productClick', this.product);
        }
      }
    },
    clickUsp(usp) {
      if (usp[2] === 'cashback') {
        this.clickCashbackUSP();
      } else if (usp[2] === 'green') {
        this.clickGreenUSP();
      } else if (usp[2] === 'package') {
        this.clickPackageUSP();
      }
    },
    clickGreenUSP() {
      if (!this.disabled) {
        this.$emit('switchToGreen');
      }
    },
    clickCashbackUSP() {
      if (!this.disabled) {
        this.$emit('pricing');
      }
    },
    clickPackageUSP() {
      if (!this.disabled) {
        this.$emit('showPackage');
      }
    },
  },
};
</script>

<style lang="scss">
@use 'assets/scss/_variables/colors' as colors;
@use 'assets/scss/_helpers/display' as display;
@use 'assets/scss/_helpers/typography' as typography;
@use 'assets/scss/all' as *;

.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.usps {
  transition: height 1s linear;
}

.product-overlay {
  display: none;
  background: linear-gradient(90deg,
      rgb(255, 255, 255, 0.15),
      rgb(255, 255, 255, 1));
  background-size: 400% 400%;
  animation: loadergradient 2s ease-out infinite;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 900;
  transform: translateZ(0);
  will-change: transform;
}

.product-rank {
  position: absolute;
  background: #f9fdfe;
  width: 40px;
  height: 40px;
  left: 0;
  color: colors.$link-base-default;
  justify-content: center;
  align-content: center;
  display: flex;
  line-height: 40px;
  top: 0;
  border: 1px solid #c4e3ed;
  border-top-width: 0;
  border-left-width: 0;
  border-radius: 35px;
  border-bottom-left-radius: 0;
  border-top-right-radius: 0;
  border-top-left-radius: 16px;

  .product-inner-rank {
    margin-left: -7px;
    width: 16px;
    text-align: center;
    margin-top: -1px;
  }

  @include breakpoint-down(sm) {
    width: 34px;
    height: 34px;

    .product-inner-rank {
      margin-left: 1px;
      width: 16px;
      text-align: center;
      margin-top: -7px;
      font-size: 15px;
    }
  }
}

.is-loading .product-rank .product-inner-rank {
  color: transparent !important;
}

.is-loading .product-cheapest {
  opacity: 0 !important;
  transition: none;
}

.product-cheapest {
  @include content-small;

  transition: opacity .15s;
  font-weight: 600;
  display: flex;
  position: absolute;
  justify-content: center;
  align-content: center;
  align-items: center;
  padding: 8px 12px;
  bottom: 100%;
  right: 16px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  border-bottom-left-radius: 0;
  border: 1px solid $border-promotion;
  border-bottom: 0;
  color: colors.$text-base;
  background-color: $element-yellow-60;

  .icon-element {
    background: currentColor;
    margin-right: 6px;
  }
}

.comparison-body.is-loading .product-overlay {
  display: block;
  position: absolute;
}

@keyframes loadergradient {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}

.product {
  display: grid;
  margin-bottom: 24px;
  position: relative;
  overflow: hidden;
  color: colors.$text-base;
  @include shadow-small;
  border-radius: 16px;
  background: colors.$block-base;

  @include breakpoint-down(md) {
    margin-bottom: 16px;
  }

  &.energy {
    grid-template-columns: auto 1fr auto;
    grid-row-gap: 16px;
    grid-template-rows: auto auto auto;
    overflow: inherit;
    border-radius: 16px;

    border-left: 0;
    margin-top: 32px;
    margin-bottom: 0;
    padding: 18px 24px;

    @include breakpoint-up(sm) {
      padding: 32px;
      padding-bottom: 44px;
    }

    @include breakpoint-up(lg) {
      margin-top: 0;
      margin-bottom: 32px;
    }

    .element.usps {
      grid-column: 1/4;

      @include breakpoint-up(sm) {
        grid-column: 1/ span 2;
      }

    }

    .element.cta {
      width: 100%;

      @include breakpoint-down(sm) {
        display: none;
      }

      &.energy {
        display: none;
        grid-column: 3/3;

        @include breakpoint-down(sm) {
          display: flex;
          justify-content: flex-end;
        }
      }

    }

    .cashback_label {
      font-weight: 500;
      text-align: center;

      &.energy {
        @include breakpoint-down(sm) {
          display: none;
        }
      }

      &.mobile {
        display: none;

        @include breakpoint-down(sm) {
          display: flex;
          grid-column: 3;
          height: 40px;
          font-weight: bold;
          padding: 10px 14px;
        }
      }
    }

    &.disabled {
      // Overrule colors for disabled products
      filter: grayscale(100%);

      img {
        opacity: 0.6;
        cursor: not-allowed;
      }

      .button.primary {
        opacity: 0.5;
        cursor: not-allowed;
        color: #000;
        background: #80b8cb !important;

        &:hover {
          border-color: transparent;
        }
      }

      .element.price,
      .element.more {
        cursor: not-allowed;
      }
    }
  }

  &.cheapest {
    border: 1px solid $border-button !important;
    margin-top: 54px;

    @include breakpoint-up(lg) {
      margin-top: 24px;
    }
  }

  &.first_product {
    margin-top: 0;
  }
  @include breakpoint-down(xs) {
    border-radius: 0;
    padding: 24px;
  }

  .element.usps {
    .usp {
      .icon-element {
        background-color: colors.$link-positive-default;
      }
    }
  }

  .usps,
  .more {
    .icon-element {
      width: 16px;
      height: 16px;
      min-width: 16px;
      min-height: 16px;
    }
  }

  .more {
    .icon-element {
      background-color: colors.$link-base-default;
      margin-left: 0 !important;
    }
  }

  .price-container {
    display: flex;
    align-items: flex-end;
    flex-flow: column;
  }

  .element.price {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .provider_logo img {
    width: 113px;

    @include breakpoint-up(lg) {
      width: 95px;
    }

    @include breakpoint-up(xl) {
      width: 113px;
    }
  }

  .provider_logo.logo_small img {
    width: 85px;
  }

  .usps {
    grid-column: 1/ span 2;

    // @include breakpoint-down(xs) {
    //   margin-bottom: 12px;
    // }

    .usp-list {
      display: grid;
      grid-template-rows: auto auto;
      grid-gap: 10px;

      .icon-element {
        margin-left: 8px;

        @include breakpoint-up(md) {
          margin-left: 0px;
        }
      }
    }

    .year_price {
      font-weight: bold;
      margin-right: 8px;
    }

    .usp {
      display: inline-flex;
      align-content: center;
      align-items: center;
    }

    .icon-element {
      align-self: flex-end;
      margin-right: 12px;
    }

    .attention {
      background-color: colors.$grey-10;
      color: colors.$link-base-default;
      border: 1px solid colors.$border-base;
      padding: 6px 12px;
      border-radius: 5px;
      margin-right: 12px;

      &+span {
        font-weight: bold;

        @include breakpoint-up(sm) {
          font-size: 18px;
        }
      }
    }
  }

  .energy .usps {
    margin-top: 12px;
  }

  .expected_speed {
    font-weight: bold;
  }

  .expected_speed_label {
    font-size: 0.9em;
  }

  .more-info {
    grid-column: 1 / -1;
  }

  .more {
    .icon-element {
      margin-left: 5px;
      margin-top: 1px;
      transition: transform 1.2s ease;
    }

    &.expanded {
      .icon-element {
        transform: rotate(45deg);
      }
    }
  }

  .cta {
    grid-column: 2/4;
    justify-self: flex-end;

    .btn {
      width: 100%;

      >span {
        white-space: nowrap;
      }
    }
  }

  .cashback_label {
    color: #15a35f;
    background-color: #e0fff0;
    padding: 10px 12px;
    border-radius: 16px;
    margin-left: 24px;
    margin-right: 24px;
  }

  .cashback_label_negative {
    color: #9f2025;
    background-color: #f5e2e3;
  }
}

.theme-energy-price-focus .product {
  .element.price {
    .subtext {
      .icon-element {
        margin-left: 2px;
        background: colors.$text-subtle;
      }
    }

    @include breakpoint-down(sm) {
      border-left: 0;
      border-bottom: 1px solid #edf5f8;
      grid-row: 1;
    }
  }
}

.theme-energy-price-focus .product {
  grid-template-columns: 1fr 1fr auto;
  grid-template-rows: auto auto auto;
  border: 1px solid #c4e3ed;

  @include breakpoint-down(sm) {
    border-radius: 0;
    border-left-width: 0;
    border-right-width: 0;
  }

  .more {
    grid-column: 1 / 4;
    grid-row: 3;
    display: flex;
    justify-content: center;
    position: absolute;
    left: -32px;
    right: -32px;
    bottom: 0;
    background: #f9fdfe;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    border-top: 1px solid #d4e5ec;
    padding: 10px;

    .icon-element {
      position: relative;
    }

    @include breakpoint-down(sm) {
      grid-column: 1 / 3;
      color: colors.$link-base-default;
      align-self: center;
      justify-self: flex-start;
      position: relative;
      cursor: pointer;
      padding: 0;
      left: inherit;
      right: inherit;
      background: none;
      border-top: 0;
    }
  }

  .usps {
    @include breakpoint-up(md) {
      grid-column: 1 / 3;
    }
  }

  .alt-layout {
    &.usps {
      margin-top: 0;
    }

    grid-column: 1 / 4;
  }

  .provider_logo {
    grid-column: 1 / 3;
    border-bottom: 1px solid #edf5f8;
    padding-bottom: 15px;
  }

  .price-container {
    align-self: center;
    align-items: flex-start;
    width: 100%;
    background: #f9fdfe;
    margin-bottom: 16px;
    border-radius: 16px;
    padding: 16px;
    border: 1px solid #d4e5ec;

    .subtext {
      margin-top: 8px;
      margin-left: 5px;
    }

    @include breakpoint-down(sm) {
      background: none;
      padding: 0;
      border-width: 0;
    }
  }

  .cta {
    grid-row: 3 / 3;

    .button.primary {
      justify-content: center;

      .icon-element {
        display: none;
      }
    }
  }

  .element.price {
    .supertitle {
      font-weight: 500;
      font-size: 26px;
    }
  }

  .price {
    grid-row: 1/ 3;
    grid-column: 3;
    border-left: 1px solid #edf5f8;
    padding-left: 20px;
  }
}
</style>
